import { render, staticRenderFns } from "./OptionsForm.vue?vue&type=template&id=0497911c"
import script from "./OptionsForm.vue?vue&type=script&lang=js"
export * from "./OptionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports